if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          element.style.display = 'none'
        });
        activeMedia?.classList?.add('is-active');
        console.log("is active ", activeMedia)
        activeMedia.style.display = "block"

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);

            console.log("aactiveThumbnail..", activeThumbnail.getAttribute("thumbnail-alt"))
            const parentUl = document.querySelector(".parentul");
            parentUl.setAttribute("data-color", activeThumbnail.getAttribute("thumbnail-alt"));

            const uls = document.querySelectorAll('[data-color]');
            const dynamicAttributeValue = uls[0].getAttribute('data-color');
            this.toggleListItems(uls, 'thumbnail-alt', dynamicAttributeValue);



            const mobileScreenWidth = 768;
            const parentUlmain = document.querySelector(".parentul-main");
            parentUlmain.setAttribute("data-main-color", activeThumbnail.getAttribute("thumbnail-alt"));
            
            const ulsMain = document.querySelectorAll('[data-main-color]');
            
            const dynamicDiffAttributeValue = ulsMain[0].getAttribute("data-main-color");
            
            this.mobileOnlyToggle(mobileScreenWidth, ulsMain, 'thumbnail-alt', dynamicAttributeValue);
            
            window.addEventListener('resize', () => {
              this.mobileOnlyToggle(
                mobileScreenWidth,
                ulsMain,
                "thumbnail-alt",
                dynamicAttributeValue
              );
            });
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      toggleListItems(uls, attributeName, dynamicAttributeValue) {
        uls.forEach((ul) => {
          const lis = ul.querySelectorAll("li");
          lis.forEach((li) => {
            const attrValue = li.getAttribute(attributeName);
            li.style.display = attrValue === dynamicAttributeValue ? "block" : "none";
          });
        });
      }

      mobileOnlyToggle(
        mobileScreenWidth,
        uls,
        attributeName,
        dynamicAttributeValue
      ) {
        if (window.innerWidth > mobileScreenWidth) return;
      
        uls.forEach((ul) => {
          const lis = ul.querySelectorAll("li");
          lis.forEach((li) => {
            const attrValue = li.getAttribute(attributeName);
            li.style.display = attrValue === dynamicAttributeValue ? "flex" : "none";
            li.classList.toggle("mobile-list-item");
          });
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

